import axios from "axios";
import { useQuery } from "react-query";

import { Resource } from "../model";
import { sleep } from "../helpers";

export const useResource = (name: string) => {
  const { status, data, error, isFetching } = useQuery(
    `model/${name}`,
    async () => {
      await sleep(1000);
      const { data } = await axios.get<Resource>(`/api/model/${name}`);
      return data;
    },
    {
      staleTime: Infinity,
    }
  );

  return { status, data, error, isFetching };
};
